"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.olapicResponseMediaSchema = void 0;
var _zod = require("zod");
var _OlapicResponseMediaItem = require("./OlapicResponseMediaItem");
const olapicResponseMediaSchema = exports.olapicResponseMediaSchema = _zod.z.object({
  data: _zod.z.object({
    _embedded: _zod.z.object({
      media: _zod.z.array(_OlapicResponseMediaItem.olapicMediaItemSchema)
    }),
    _links: _zod.z.object({
      next: _zod.z.object({
        href: _zod.z.string()
      }).optional()
    }).default({})
  })
});
